import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  // Replace 'YOUR_FORM_ID' with your actual Formspree form ID
  // Get it from https://formspree.io/ after signing up
  const FORMSPREE_ENDPOINT = process.env.REACT_APP_FORMSPREE_ID 
    ? `https://formspree.io/f/xkoojedn`
    : 'https://formspree.io/f/xkoojedn';

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAlert(null);

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setAlert({ 
          type: 'success', 
          message: 'Thank you! We have received your message and will contact you shortly.' 
        });
        setFormData({ name: '', email: '', company: '', message: '' });
      } else {
        const data = await response.json();
        setAlert({ 
          type: 'error', 
          message: data.error || 'Failed to send message. Please try again.' 
        });
      }
    } catch (error) {
      setAlert({ 
        type: 'error', 
        message: 'Failed to send message. Please check your connection and try again.' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="section">
      <div className="container">
        <div className="contact-box">
          <h2>Let's Build Something</h2>
          <p>Have an idea or a complex problem? Let's talk.</p>
          
          {alert && (
            <div className={`alert alert-${alert.type === 'success' ? 'success' : 'error'}`}>
              {alert.message}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Business Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="company"
                placeholder="Company (optional)"
                value={formData.company}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <textarea
                rows="5"
                name="message"
                placeholder="Tell us about your project"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button 
              type="submit" 
              className="btn btn-primary btn-block"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
